import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { NavListContext } from 'App';
import { Grid, InfiniteScroll, PullToRefresh, SpinLoading, Swiper, SwiperRef, Toast } from 'antd-mobile';
import { GridItem } from 'antd-mobile/es/components/grid/grid';
import { useContext, useEffect, useRef, useState } from 'react';
import { AiOutlineArrowDown, AiOutlineArrowUp, AiOutlineDown } from 'react-icons/ai';
import { PageParams } from 'services/CommonDT';
import { DateTimeParams, PageQueryParams, SearchParams, SortParams } from 'services/apis/cnt2/CommonDT';
import PostsApi, { PagePostDT } from 'services/apis/cnt2/post-api';
import { defaultPageParams } from 'services/request';
import { useImmer } from 'use-immer';
import { convertToShanghaiTime } from 'utils/dateUtil';
import sleep from 'utils/threadUtil';
import ImageList from '../image-list';

const ImageListPullScroll = (data: {
  changeIndexEnabled: boolean;
  onIndexChange: (index: number) => void;
  sortType: string;
  termTaxonomy: string;
  termId: string;
  termName: string;
  showTermNamePrefix: boolean;
  staticPostList: PagePostDT[];
}) => {
  const swiperRef = useRef<SwiperRef>(null);
  const navList = useContext(NavListContext).navList;

  const [hasMore, setHasMore] = useState(true);
  // const postCount = useRef(0);
  // const [postList, setPostList] = useState<PagePostDT[]>([]);
  const [pageParams, updatePageParams] = useImmer<PageParams>(defaultPageParams);

  const queryClient = useQueryClient();

  const fetchPagePost = async (
    params: {
      termId?: string;
      termTaxonomy?: string;
    },
    _data: PageQueryParams,
    initial = false
  ) => {
    // 排序参数
    const sortParams: SortParams =
      data.sortType === 'latest'
        ? { sortIsDesc: 1, sortType: 1 }
        : data.sortType === 'trend'
          ? { sortIsDesc: 1, sortType: 7 }
          : data.sortType === 'hotest'
            ? { sortIsDesc: 1, sortType: 7 }
            : {};
    // 获取三月前的1号日期, 会跨年处理
    let threeMonthsAgo = new Date();
    threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 3);
    threeMonthsAgo.setDate(1);
    threeMonthsAgo.setHours(0, 0, 0, 0);
    threeMonthsAgo = convertToShanghaiTime(threeMonthsAgo);
    const dateTimeParams: DateTimeParams = data.sortType === 'trend' ? { startDate: threeMonthsAgo } : {};
    // 请求接口
    const response = await PostsApi.page(params, {
      ..._data,
      sortParams: sortParams,
      dateTimeParams: dateTimeParams,
    });
    console.log('PostsApi.page', response);
    if (response.code === 0 && response.successful) {
      const data = response.result.records;
      // if (initial) {
      //   setPostList(data);
      // }
      return data;
    }
  };
  const fetchPostCount = async (params: { termId: string; termTaxonomy: string }) => {
    // 请求接口
    const response = await PostsApi.getPostCount(params);
    if (response.code === 0 && response.successful) {
      const data = response.result;
      // postCount.current = data;
      return data;
    }
  };
  const loadMore = async () => {
    console.log('loadMore');

    const _pageParams = {
      current: pageParams.current + 1,
      pageSize: pageParams.pageSize,
    };
    updatePageParams(_pageParams);

    const append = await fetchPagePost(
      {
        termId: navList.top2TermNow?.termUuid || navList.top1TermNow?.termUuid || navList.btmTermNow?.termUuid,
        termTaxonomy: 'category',
      },
      { pageParams: _pageParams }
    );
    if (!append) {
      throw new Error('mock request failed');
    } else {
      // setPostList((val) => {
      //   return [...val, ...append];
      // });
      setHasMore(append.length >= pageParams.pageSize);
    }
    await sleep(3000);
  };

  // console.log('ImageListPullScroll', data);
  const fetchPagePostQuery = useQuery({
    queryKey: ['fetchPagePost', { termId: data.termId, termTaxonomy: data.termTaxonomy }, { sortType: data.sortType }],
    queryFn: () => {
      // 静态数据不需要获取
      if (data.staticPostList) {
        return false;
      }
      return fetchPagePost(
        {
          termId: data.termId,
          termTaxonomy: data.termTaxonomy,
        },
        { pageParams: defaultPageParams },
        true
      );
    },
  });
  const fetchPagePostMutation = useMutation({
    mutationKey: [
      'fetchPagePost',
      { termId: data.termId, termTaxonomy: data.termTaxonomy },
      { sortType: data.sortType },
    ],
    mutationFn: (pageParams: PageParams) => {
      return fetchPagePost(
        {
          termId: data.termId,
          termTaxonomy: data.termTaxonomy,
        },
        { pageParams: pageParams },
        true
      );
    },
    onSuccess: async (_data, variables, context) => {
      queryClient.setQueryData(
        ['fetchPagePost', { termId: data.termId, termTaxonomy: data.termTaxonomy }, { sortType: data.sortType }],
        (old: any[]) => {
          console.log('old: ', old, 'data: ', _data);
          return [...old, ..._data];
        }
      );
    },
    onError: async (error, variables, context) => {
      console.log('网络异常, 请稍后再试', error, variables, context);
    },
  });
  // 不显示资源总数
  // const fetchPostCountQuery = useQuery({
  //   queryKey: ['fetchPostCount', { termId: data.termId, termTaxonomy: data.termTaxonomy }],
  //   queryFn: () => {
  //     return fetchPostCount({
  //       termId: data.termId,
  //       termTaxonomy: data.termTaxonomy,
  //     });
  //   },
  // });

  return (
    <>
      {navList.top2TermList && (
        <Swiper
          className=" min-h-96"
          direction="horizontal"
          loop={false}
          rubberband={true}
          indicator={() => null}
          ref={swiperRef}
          onIndexChange={(index) => {
            // 某些页面不能侧滑（比如 /term）
            console.log(!data.changeIndexEnabled);
            console.log(navList.top2TermList);
            if (!data.changeIndexEnabled) {
              return;
            }
            // TODO 禁止点击, 有数据后再开放
            // Toast.clear();
            // Toast.show("前方区域, 请稍后探索吧 ❤");
            // return;
            // console.log("index", index);
            // fetchPagePost(
            //   {
            //     termId:
            //       navList.top2TermList[index].termUuid || navList.top1TermNow.termUuid || navList.btmTermNow.termUuid,
            //     termTaxonomy: "category",
            //   },
            //   { pageParams: pageParams },
            //   true
            // );
            // fetchPagePostQuery.refetch();
            data.onIndexChange(index);
          }}
        >
          {/* 不知道为什么会多出一个 */}
          {((navList.top2TermList && navList.top2TermList.length > 0 && navList.top2TermList) || [navList.top1TermNow])
            .slice(0, !data.changeIndexEnabled ? 1 : navList?.top2TermList?.length ? navList.top2TermList.length : 1)
            ?.map((item, index) => (
              <Swiper.Item key={item?.termUuid || index}>
                {/* 下拉刷新 */}
                <PullToRefresh
                  disabled={false}
                  threshold={50}
                  pullingText={
                    <div className=" flex justify-center items-center">
                      <AiOutlineArrowDown
                        color="#666"
                        size={24}
                        className=" mr-2 inline-block"
                      />
                      <div className=" text-xs inline-block">
                        <div>下拉可以刷新</div>
                        <div>当前时间 {new Date().toLocaleTimeString()}</div>
                      </div>
                    </div>
                  }
                  canReleaseText={
                    <div className=" flex justify-center items-center">
                      <AiOutlineArrowUp
                        color="#666"
                        size={24}
                        className=" mr-2 inline-block"
                      />
                      <div className=" text-xs inline-block">
                        <div>释放立即刷新</div>
                        <div>当前时间 {new Date().toLocaleTimeString()}</div>
                      </div>
                    </div>
                  }
                  refreshingText={
                    <div className=" flex justify-center items-center">
                      <SpinLoading
                        style={{ '--size': '24px', '--color': '#666' }}
                        className=" mr-2 inline-block"
                      />
                      <div className=" text-xs inline-block">
                        <div>正在刷新...</div>
                        <div>当前时间 {new Date().toLocaleTimeString()}</div>
                      </div>
                    </div>
                  }
                  onRefresh={async () => {
                    // 静态数据不刷新
                    if (data.staticPostList) {
                      await sleep(1500);
                      return;
                    }
                    console.log('onRefresh');
                    updatePageParams(defaultPageParams);
                    fetchPagePostQuery.refetch();
                    // fetchPostCountQuery.refetch();
                    await sleep(1500);
                  }}
                >
                  <ImageList
                    termName={
                      !data.showTermNamePrefix
                        ? data.termName
                        : data.staticPostList || !data.termId
                          ? data.termName
                          : (navList.top2TermNow?.termName ||
                              navList.top1TermNow?.termName ||
                              navList.btmTermNow?.termName) + (!data.termName ? '' : ' : ' + data.termName)
                      // + (fetchPostCountQuery && ' (资源总数: ' + fetchPostCountQuery.data + ')')
                    }
                    termId={data.staticPostList ? null : data.termId}
                    postList={data.staticPostList ? data.staticPostList : fetchPagePostQuery.data}
                    showMore={true}
                    showChange={false}
                  />
                </PullToRefresh>
              </Swiper.Item>
            ))}
        </Swiper>
      )}
      {/* 下拉加载更多 */}
      {
        <InfiniteScroll
          threshold={600}
          hasMore={data.staticPostList ? false : hasMore}
          // hasMore={hasMore}
          // hasMore={false}
          loadMore={async () => {
            if (fetchPagePostMutation.isPending) {
              return;
            }
            const _pageParams = {
              current: pageParams.current + 1,
              pageSize: pageParams.pageSize,
            };
            updatePageParams(_pageParams);
            fetchPagePostMutation.mutate(_pageParams);
            await sleep(1500);
          }}
        />
      }
      {/* 是否显示网络请求状态 */}
      {false && (
        <>
          <div className=" fixed bottom-0 left-0 bg-slate-200 z-10 p-2 rounded-md shadow-md text-left">
            {'status:\n' + JSON.stringify(fetchPagePostMutation.status, null, 2)}
            <Grid columns={1}>
              <GridItem>isPending: {fetchPagePostMutation.isPending ? 1 : 0}</GridItem>
              <GridItem>isSuccess: {fetchPagePostMutation.isSuccess ? 1 : 0}</GridItem>
              <GridItem>isPaused: {fetchPagePostMutation.isPaused ? 1 : 0}</GridItem>
              <GridItem>isError: {fetchPagePostMutation.isError ? 1 : 0}</GridItem>
              <GridItem>isIdle: {fetchPagePostMutation.isIdle ? 1 : 0}</GridItem>
            </Grid>
          </div>
        </>
      )}
    </>
  );
};

export default ImageListPullScroll;
